import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=06019a78&scoped=true&"
import script from "./Root.vue?vue&type=script&setup=true&lang=js&"
export * from "./Root.vue?vue&type=script&setup=true&lang=js&"
import style0 from "@/assets/styles/payout-styles-main.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./Root.vue?vue&type=style&index=1&id=06019a78&prod&lang=scss&"
import style2 from "./Root.vue?vue&type=style&index=2&id=06019a78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06019a78",
  null
  
)

export default component.exports